import WorkspaceSettingsPage from "./WorkspaceSettingsPage";

export default WorkspaceSettingsPage;
